import { makeStyles } from '@material-ui/core'
import palette from 'theme/palette'

const styles = makeStyles((theme) => ({
  alert: {
    alignItems: 'center',
  },
  alertText: {
    position: 'relative',
    top: 1,
  },
  mainRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(3),
  },
  mainLabel: {
    display: 'block',
    fontWeight: theme.typography.fontWeightMedium,
    cursor: 'pointer',
  },
  switchBase: {
    '&$checked': {
      color: palette.primary.main,
    },
    '&$checked + $track': {
      backgroundColor: palette.primary.main,
    },
  },
  checked: {},
  track: {},
}))

export default styles
